<div class="lineout row settings-provider-item">
	<div data-ref="name"></div>
	<div class="row-compact">
		<button class="lineout" data-ref="edit">edit</button>
		<button class="lineout" data-ref="copy">copy</button>
		<button class="lineout" data-ref="delete">delete</button>
	</div>
</div>
